import React from "react";
import ContentLoader from "react-content-loader";

const SliderEventsLoader = () => {
  return (
    <section className={"sliderEvents isActive"}>
      <h2>Proximos Eventos</h2>

      <div className="sliderEvents__container">
        <div className="sliderEvents__line">
          <ContentLoader
            height="100%"
            width="100%"
            viewBox="0 0 350 600"
            backgroundColor="#f5f5f5"
            foregroundColor="#dbdbdb"
          >
            <rect x="4" y="8" rx="3" ry="3" width="8" height="570" />
            <rect x="102" y="69" rx="3" ry="3" width="102" height="7" />
            <circle cx="48" cy="63" r="18" />
            <rect x="95" y="95" rx="3" ry="3" width="178" height="6" />
            <rect x="105" y="169" rx="3" ry="3" width="102" height="7" />
            <rect x="95" y="147" rx="3" ry="3" width="178" height="6" />
            <circle cx="51" cy="163" r="18" />
            <rect x="98" y="195" rx="3" ry="3" width="178" height="6" />
            <rect x="107" y="265" rx="3" ry="3" width="102" height="7" />
            <rect x="97" y="243" rx="3" ry="3" width="178" height="6" />
            <circle cx="53" cy="259" r="18" />
            <rect x="100" y="291" rx="3" ry="3" width="178" height="6" />
            <rect x="108" y="365" rx="3" ry="3" width="102" height="7" />
            <rect x="98" y="343" rx="3" ry="3" width="178" height="6" />
            <circle cx="54" cy="359" r="18" />
            <rect x="101" y="391" rx="3" ry="3" width="178" height="6" />
            <rect x="110" y="458" rx="3" ry="3" width="102" height="7" />
            <rect x="100" y="436" rx="3" ry="3" width="178" height="6" />
            <circle cx="56" cy="452" r="18" />
            <rect x="103" y="484" rx="3" ry="3" width="178" height="6" />
            <rect x="114" y="507" rx="3" ry="3" width="102" height="7" />
            <rect x="103" y="534" rx="3" ry="3" width="178" height="6" />
          </ContentLoader>
        </div>

        <div className={"sliderEvents__content"}>
          <div className="sliderEvents__content__text">
            <ContentLoader
              height="100%"
              width="100%"
              viewBox="0 0 265 230"
              backgroundColor="#f5f5f5"
              foregroundColor="#dbdbdb"
            >
              <rect x="15" y="15" rx="4" ry="4" width="200" height="25" />
              <rect x="15" y="75" rx="3" ry="3" width="215" height="15" />
              <rect x="15" y="105" rx="3" ry="3" width="50" height="15" />
              <rect x="75" y="105" rx="3" ry="3" width="50" height="15" />
              <rect x="135" y="105" rx="3" ry="3" width="50" height="15" />
              <rect x="15" y="165" rx="2" ry="2" width="150" height="50" />
              <rect x="215" y="180" rx="2" ry="2" width="40" height="20" />
            </ContentLoader>
          </div>

          <div className="sliderEvents__content__image">
            <ContentLoader
              height="100%"
              width="100%"
              viewBox="0 0 265"
              backgroundColor="#f5f5f5"
              foregroundColor="#dbdbdb"
            >
              <rect x="15" y="50" rx="2" ry="2" width="100%" height="100%" />
            </ContentLoader>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SliderEventsLoader;
